module.exports = __webpack_public_path__ + "img/universiti_teknologi_petronas.ea2617ed.jpg";